import React from 'react';
import { useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import DSBox from '../../../design-system/DSBox';
import DSPaper from '../../../design-system/Paper/DSPaper';
import DSValueTypography from '../../../design-system/Typography/DSValueTypography';
import DSIconButton from '../../../design-system/DSIconButton';
import { KLYDO_YELLOW } from '../../../consts/colors';

type KlydoChimeInputUploadedProps = {
  chimeName?: string;
  onRemoveFile: () => void;
  isPlaying?: boolean;
  onPlayPause?: () => void;
};

const KlydoChimeInputUploaded = ({
  chimeName,
  onRemoveFile,
  isPlaying = false,
  onPlayPause,
}: KlydoChimeInputUploadedProps) => {
  const { spacing, palette } = useTheme();

  return (
    <DSPaper
      sx={{
        display: 'flex',
        padding: spacing(2, 3),
        borderRadius: '28px',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',
        backgroundColor: palette.white[5],
        transition: 'all 0.2s ease',
      }}
    >
      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: spacing(1),
        }}
      >
        {onPlayPause && (
          <DSIconButton
            onClick={onPlayPause}
            sx={{
              padding: spacing(0.5),
              color: KLYDO_YELLOW,
              '&:hover': {
                backgroundColor: 'rgba(255, 216, 72, 0.1)',
              },
            }}
          >
            {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </DSIconButton>
        )}
        <DSValueTypography color={palette.text.primary}>
          {chimeName || 'Chime uploaded'}
        </DSValueTypography>
      </DSBox>
      <DSIconButton
        onClick={onRemoveFile}
        sx={{
          '&:hover': {
            backgroundColor: palette.white[10],
          },
          color: palette.text.secondary,
          transition: 'all 0.3s ease',
        }}
      >
        <CloseIcon />
      </DSIconButton>
    </DSPaper>
  );
};

export default KlydoChimeInputUploaded;
